import { createApi } from '@reduxjs/toolkit/query/react'
import { GraphQLClient } from 'graphql-request'
import { hydrate } from '../../actions'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { graphqlRequestBaseQuery } = require('@rtk-query/graphql-request-base-query')
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { getEnvVar } from '@client-hub/shared/utils/env'
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { EnvironmentVariable } from '@client-hub/shared/constants/env'
import createFetchWithTimeout from '../../utils/createFetchWithTimeout'
import { API_REQUEST_TIMEOUT } from '../../constants'

export const client = new GraphQLClient(getEnvVar(EnvironmentVariable.GCS_API_URL), {
  fetch: createFetchWithTimeout(API_REQUEST_TIMEOUT),
})

export const api = createApi({
  reducerPath: 'gcsApi',
  baseQuery: graphqlRequestBaseQuery({ client }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === hydrate.toString()) {
      return (action['payload'] as any)[reducerPath]
    }
    return undefined
  },
  endpoints: () => ({}),
})
